export const PHONE_VALIDATION_REGEX =
  /^[\+]?[(]?[0-9]{1,4}[)]?[-\s\.]?[0-9]{1,4}[-\s\.]?[0-9]{4,6}$/im;
export const EMAIL_VALIDATION_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const getAuthToken = () => localStorage.getItem("AUTH_TOKEN");
export const getRefreshToken = () => localStorage.getItem("REFRESH_TOKEN");
export const getSocketID = () => localStorage.getItem("SOCKET_ID");

export const checkInputFormat = (input: string) => {
  if (PHONE_VALIDATION_REGEX.test(input)) {
    return "phone";
  }
  if (EMAIL_VALIDATION_REGEX.test(input)) {
    return "email";
  }
};

export const checkIsAnywhereCommunity = (business?: BusinessType) => {
  if (!business) return false;
  const anyWhereCommunitiesList = business?.communities?.filter(
    (community: CommunityType) => community?.isGlobal
  );
  return (
    !!anyWhereCommunitiesList?.length ||
    business?.onboardingCommunityDetails?.isGlobal
  );
};

export const isFutureDate = (date: string) => {
  const moment = require("moment"); // Make sure to import moment

  const dateString = date; // Your date string
  const targetDate = moment(dateString); // Parse the date string

  return targetDate.isAfter(moment()); // Compare with the current date
};

export const getBaseUrl = () => {
  return process.env.REACT_APP_APPLICATION_ENV === "DEV"
    ? "https://d3pqdp9dade80h.cloudfront.net"
    : process.env.REACT_APP_APPLICATION_ENV === "STAGING"
    ? "https://onboarding-portal-staging.bludot.io"
    : process.env.REACT_APP_APPLICATION_ENV === "PROD"
    ? "https://business.openrewards.com"
    : "http://localhost:3000";
};
